import React from "react";
import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//Components
import { FileUploader } from "./FileUpload";

import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

//Additional Imports
import { Link } from "react-router-dom";
// import { Button } from "@material-ui/core";
// import Box from "@material-ui/core/Box";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import LinearProgress from "@material-ui/core/LinearProgress";
// import CloudDownloadRoundedIcon from "@material-ui/icons/CloudDownloadRounded";
// import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";

import {
    get3DRecords,
    delete3DRecord,
} from "../../Redux/actions";

import {
  handle_recordedBlobs,
  handle_webCam,
  handle_videoRecorder,
  handle_videoRecordStatus,
  handle_activePage,
} from "../../Redux/reducer";

import axios from 'axios';
import { toast} from 'react-toastify';

var elem = document.documentElement;

//Functional Component Begins
const HiRenderDemo = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const all3DRecords = useSelector((state) => state.auth.all3DRecords);
  var downloadLink = "https://www.airender.co.in:8000/output/final/";
  if(all3DRecords && all3DRecords.name) {
    downloadLink = downloadLink + all3DRecords.name +".7z";
  } else {
    downloadLink = downloadLink + "HiRenderDemo_Package.7z";
  }
  //Record Reference(video tag)
  const recordedRef = useRef();

  let mediaRecorder;

  //Setting recordedVideo
  const recordedVideo = recordedRef.current;

  //Bool to check if videocam is on
  const isWebCamOn = useSelector((state) => state.auth.isWebCamOn);

  //Bool to check if video recording has started
  const isVideoRecorderStarted = useSelector(
    (state) => state.auth.isVideoRecorderStarted
  );

  //Bool to check if video is recorded
  const isVideoRecorded = useSelector((state) => state.auth.isVideoRecorded);

  //Array to store blobs of recording
  const recordedBlobs = useSelector((state) => state.auth.recordedBlobs);

  //const [playing, setPlaying] = useState(false);

  //fullscreen variable
  const [fullScreen, setFullScreen] = useState("");

  //Recording counter (10 second counter)
  var [recordCounter, setRecordCounter] = useState(10);

  const [files, setFiles] = useState([]);
  const [manualUpload, setManualUpload] = useState(false);
  const onSuccess = (savedFiles) => {
    setFiles(savedFiles)
    setManualUpload(true)
    console.log("hiRenderDemo:onSuccess:savedFiles = ",savedFiles);
  };

  var autoPlayAndDownload = false;

  // console.log(
  //   "hiRenderDemo:isWebCamOn,isVideoRecorderStarted,isVideoRecorded,recordedBlobs = ",
  //   isWebCamOn,
  //   isVideoRecorderStarted,
  //   isVideoRecorded,
  //   recordedBlobs
  // );

  //Function that enables fullscreen
  const goFullScreen = () => {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  };
  const closeScreen = async () => {
    if (!document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
  };

  const handleFullScreen = (args) => {
    setFullScreen(args);
    if (args === "") closeScreen();
    else goFullScreen();
    console.log("HiRender:args = ", args);
  };
  // console.log("ani:recordedBlobs: is resetting?", recordedBlobs);
  useEffect(() => {
    // if(isVideoRecorderStarted == true && isVideoRecorded == false){
    const interval = setInterval(() => {
      if (isVideoRecorderStarted == true && isVideoRecorded == false) {
        setRecordCounter(recordCounter--);
        if (recordCounter < 0) {
          // setRecordDelay(true);
          handleStopWebCam();
          // dispatch(handle_videoRecorder(false));
          dispatch(handle_videoRecordStatus(true));
        }
        // console.log(
        //   "interval! isVideoRecorderStarted,isVideoRecorded = ",
        //   isVideoRecorderStarted,
        //   isVideoRecorded
        // );
      }
    }, 1000);
    return () => clearInterval(interval);
    // }
  }, [isVideoRecorderStarted, isVideoRecorded]);
  
  useEffect(() => {
    console.log("HiRenderDemo:user.email = ",user.uid)
    dispatch(get3DRecords(user.uid))
  },[])

  // const HandleManualFileUpload = (e) => {
  //   e.preventDefault();

  //   setFiles(e.target.files)
  //   setManualUpload(true)
  //   console.log("FileUploader:HandleManualFileUpload:e.target.files = ",e.target.files);
  //   dispatch(handle_videoRecordStatus(true))
  // }

  const handleClearVideo = () => {
    dispatch(handle_videoRecordStatus(false));
    dispatch(handle_recordedBlobs([]));
    setRecordCounter(10);
    setManualUpload(true)
    const gumVideo = document.querySelector("video#upload");
    gumVideo.remove();
    dispatch(handle_activePage("hiRender"))
  }

    var https = require('https-browserify')

    function readLocalOrServerFile(file, type, asyncFlag, callback)
          {
            console.debug("Lohith:HiRenderDemo: readLocalOrServerFile start",
              file, type, asyncFlag, callback);

            var request = new XMLHttpRequest();

            request.responseType = type;

            request.open("GET", file, asyncFlag);

            request.send();

            request.onreadystatechange = function ()
              {
                  if(request.readyState === 4)
                  {
                      if(request.status === 200 || request.status == 0)
                      {
                  console.debug("Lohith:HiRenderDemo: readLocalOrServerFile success",
                    request.responseText);

                  callback(request.responseText);
                      }
                  }
              }

          }

    function uploadDataToServer(host, port, fromFileContents, toFile) {
            console.debug("Lohith:HiRenderDemo:uploadDataToServer start",
              host, port, fromFileContents, toFile);
	    
	    var key, cert, ca;
	    var key_path = '/root/WORK/KEYS';

            readLocalOrServerFile(key_path+'/privkey.pem', 'text', true,
              (keyData) => {

                key = keyData;

                readLocalOrServerFile(key_path+'/cert.pem', 'text', true,
                  (certData) => {

                    cert = certData;

                    readLocalOrServerFile(key_path+'/chain.pem', 'text', true,
                      (caData) => {

                        ca = caData;

                        const options = {
                          key,
                          cert,
                          ca: [ca],
                          //rejectUnauthorized: false
                        };

                        var agent = new https.Agent(options);

                        var url = host + ':' + port + '/' + toFile;

                        console.debug("Lohith:HiRenderDemo:uploadDataToServer start fetch", url, options, fromFileContents);

			fetch(url, {
                          method: 'GET',
                          mode: 'no-cors',
                          //body: fromFileContents,
                          agent
                        }).then((res) => {
      			  console.log("RES = ",res);
			  console.log("RES.BLOB = ",res.blob());
      			  res.blob().then((result)=>{
      			    console.log("HiRenderDemo:handleGet3DFiles : /download : result",result)
      			  });
      			  res.blob().then(blob => {
        		    let url = window.URL.createObjectURL(blob);
        		    let a = document.createElement('a');
        		    a.href = url;
        		    a.download = 'hiRenderDemoPackage.7z';
        		    a.click();
      			  });
			  //dispatch(delete3DRecord(user.uid))
    			})
    			.catch((error) => {
      			  console.log("HiRenderDemo:handleGet3DFiles : /download : error", error);
    			})


			//.then(
                        //  success => {console.debug("Lohith:FileUpload:uploadDataToServer fetch success", success);}
                        //).catch(
                        //  error => {console.debug("Lohith:FileUpload:uploadDataToServer fetch error", error);}
                        //);
                      }
                    );//end readLocalOrServerFile('certificates/ca-cert.pem', 'text', true,

                  }
                );//end readLocalOrServerFile('certificates/client-cert.pem', 'text', true,

              }
            );//end readLocalOrServerFile('certificates/client-key.pem', 'text', true,

          };

	function checkIfRemoteFileExists(INPUT_URL, filename,
            isOnReadyStateChange, successCallback, errorCallback) {
            console.info("abhi76 checkIfRemoteFileExists", INPUT_URL, filename)
            
            var request = new XMLHttpRequest();
          
            var myUrl = `${INPUT_URL}`;
          
            var currTime = new Date().getTime();

            var params = {
              "uid": user.uid,
              "time": currTime,
              "filename": filename
            };

            request.open("HEAD", myUrl, false);
            //request.send(params);
            request.send(params);
          
            if(isOnReadyStateChange) {
              request.onreadystatechange = function () {
                if (this.readyState === this.DONE) {
                  if(this.status === 200) {
                    console.info("abhi76 fileURL exists",INPUT_URL)
                    
                    if(successCallback) {
                      successCallback();
                    }
                  } else {
                    console.info("abhi76 fileURL doesnt exist",INPUT_URL)
                    
                    if(errorCallback) {
                      errorCallback();
                    }
                  }
                }
              };
            }

            if(!isOnReadyStateChange) {
              return (request.status !== 404);
            }
          }

function downloadWithProgress({INPUT_URL, filename, isOnReadyStateChange,
            successCallback, isDownload, OUTPUT_FILE_NAME, isReturnUrl, errorCallback, isOnProgress} = {}) {
            console.info("abhi76 downloadWithProgress", INPUT_URL, filename)

            let startTime = null;
            if(isOnProgress) {
              startTime = new Date().getTime();
            }

            var request = new XMLHttpRequest();
            request.responseType = "blob";

            var myUrl = `${INPUT_URL}/output/final/${filename}`;
	    console.info("lohith: downloadWithProgress: myUrl = ", myUrl)
	    //downloadFile(response, OUTPUT_FILE_NAME, INPUT_URL);

            var currTime = new Date().getTime();

            var params = {
              "uid": user.uid,
              "time": currTime,
              "filename": filename
            };

	    console.info("lohith: downloadWithProgress: params = ", params)
          
            request.open("get", myUrl, true);
            //request.send(JSON.stringify(params));        
            request.send();      
            
            console.log("lohith:HiRender:LocalUser:downloadWithProgress, request, request.response = ",request, request.response);
            

            if(isOnReadyStateChange) {
              request.onreadystatechange = function () {
                console.info("lohith: downloadWithProgress: 1",this.readyState, this.status)
                if (this.readyState === 4 && this.status === 200) {
		  console.info("lohith: downloadWithProgress: 1.2",successCallback)
                  if(successCallback) {
		    console.info("lohith: downloadWithProgress: 2",isDownload)
                    if(isDownload) {
		      console.info("lohith: downloadWithProgress: 3",OUTPUT_FILE_NAME, INPUT_URL)
                      if(OUTPUT_FILE_NAME) {
                        // console.info("abhi76 downloadWithProgress isDownload OUTPUT_FILE_NAME",
                        //   this.response, OUTPUT_FILE_NAME)
                        console.log("Lohith:hiRender:LocalUser:downloadWithProgress: OUTPUT_FILE_NAME = ",OUTPUT_FILE_NAME);
                        successCallback(this.response, isDownload, OUTPUT_FILE_NAME);
                      } else if (INPUT_URL) {
                        // console.info("abhi76 downloadWithProgress isDownload INPUT_URL",
                        //   this.response, INPUT_URL)
                        console.log("Lohith:hiRender:LocalUser:downloadWithProgress: INPUT_URL = ",INPUT_URL);
                        successCallback(this.response, isDownload, null, INPUT_URL);
                      }

                    } else {
                      console.info("lohith: downloadWithProgress: 4",isReturnUrl)
                      if(isReturnUrl) {
                        // console.info("abhi76 downloadWithProgress isDownload else isReturnUrl",
                        //   this.response, this.responseURL)
                        console.log("Lohith:hiRender:LocalUser:downloadWithProgress: this.response, this.responseURL = ",this.response, this.responseURL);
                        successCallback(this.response, this.responseURL);
                      } else {
                        // console.info("abhi76 downloadWithProgress isDownload else isReturnUrl else",
                        //   this.response)
                        console.log("Lohith:hiRender:LocalUser:downloadWithProgress: this.response = ",this.response);
                        successCallback(this.response);
                      }

                    }

                  }
                }

              };
            }

            if(isOnProgress) {
              request.onprogress = function (e) {
                const percent_complete = Math.floor((e.loaded / e.total) * 100);
            
                const duration = (new Date().getTime() - startTime) / 1000;
                const bps = e.loaded / duration;
            
                const kbps = Math.floor(bps / 1024);
            
                const time = (e.total - e.loaded) / bps;
                const seconds = Math.floor(time % 60);
                const minutes = Math.floor(time / 60);
                // console.log("Lohith:hiRender:LocalUser:downloadWithProgress: isOnProgress", `${percent_complete}% - ${kbps} Kbps - ${minutes} min ${seconds} sec remaining`);
                /*console.info(
                  `${percent_complete}% - ${kbps} Kbps - ${minutes} min ${seconds} sec remaining`
                );*/
              };  
            }
          }

function downloadFile(response, OUTPUT_FILE_NAME, INPUT_URL) {
	    console.log("Lohith:hiRender:LocalUser:downloadFile: OUTPUT_FILE_NAME, INPUT_URL = ",OUTPUT_FILE_NAME, INPUT_URL);
            let fileUrl = window.URL.createObjectURL(response);
            console.log("Lohith:hiRender:LocalUser:downloadFile: response = ",response);
            const anchor = document.createElement("a");
            anchor.href = fileUrl;

            if(OUTPUT_FILE_NAME) {
              anchor.download = OUTPUT_FILE_NAME;
            } else if(INPUT_URL) {
              anchor.download = INPUT_URL.split('/').pop();
            } else {}

            document.body.appendChild(anchor);
            anchor.click();
            //document.body.removeChild(anchor);
          }

  const handleGet3DFiles = () => {
    console.log("HiRenderDemo:handleGet3DFiles")
    var host = 'https://www.airender.co.in';
        var port = 8000;
        console.log("Lohith:HiRenderDemo:handleGet3DFiles:user = ",user)
        //console.log("Lohith:file type = ",data.type)
        var toFile = "download"
        //uploadDataToServer(host, port, user, toFile)

	//*************************************************************
	
	var prevFile3dList = [];
        var currentFile3dList = [];
	let array3dFilesReceived = [];

	var baseUrl = host+':'+port
	var file3dList = "hiRenderDemo.7z"

	  //downloadFile(true, file3dList, baseUrl);

	  if(true || checkIfRemoteFileExists(baseUrl, file3dList)) {
                      console.info("abhi76 1 fileURL exists",file3dList)
                      
                      downloadWithProgress({
                        //INPUT_URL: file3dList,
                        INPUT_URL: baseUrl,
                        filename: file3dList,
                        isOnReadyStateChange: true,
                        successCallback: function successCallback (response, isDownload,
                          OUTPUT_FILE_NAME, INPUT_URL) {
                          console.info("abhi76 downloadWithProgress onreadystatechange response, isDownload, OUTPUT_FILE_NAME, INPUT_URL = ",
                            response, isDownload, OUTPUT_FILE_NAME, INPUT_URL)
                          
                          //if(isDownload) {
			    //console.log("lohith: isDownload 0")
                            downloadFile(response, OUTPUT_FILE_NAME, INPUT_URL);
                          //}
                          if(false && response instanceof Blob){
                            response.text().then(text => {
                              console.log("lohith:hiRender:LocalUser:text = ", text);
                              currentFile3dList = text.split(/\r?\n/).filter(item => item);
                              if(currentFile3dList[currentFile3dList.length-1] === 'end') {
                                currentFile3dList.pop();
                              }
                              
                              console.info("abhi76 onreadystatechange fileURL contents1",
                                text, text.length, currentFile3dList, currentFile3dList.length,
                                prevFile3dList, prevFile3dList.length)
                              
                              if(currentFile3dList.length > prevFile3dList.length) {
                                for(let idx = prevFile3dList.length; idx < currentFile3dList.length; idx++) {
                                  //let file3dxyz = `${file3dListDir}frame${idx+1}_head_xyz.npy`;
                                  //let file3dtex = `${file3dListDir}frame${idx+1}_head_tex.npy`;
                                  //let file3dtri = `${file3dListDir}frame${idx+1}_head_tri.npy`;
                                  let file3dxyz = `frame${idx+1}_head_xyz.npy`;
                                  let file3dtex = `frame${idx+1}_head_tex.npy`;
                                  let file3dtri = `frame${idx+1}_head_tri.npy`;
                                  let tempIdx = idx;
                                  let tempCurrentFile3dListLength = currentFile3dList.length;
                                  array3dFilesReceived[tempIdx] = [];
                                  downloadWithProgress({
                                    //INPUT_URL: file3dxyz,
                                    INPUT_URL: baseUrl,
                                    filename: file3dxyz,
                                    isOnReadyStateChange: true,
                                    successCallback: function successCallback (response, returnUrl) {
                                      
                                      array3dFilesReceived[tempIdx][0] = window.URL.createObjectURL(response);
                                      array3dFilesReceived[tempIdx][3] = returnUrl;

                                      console.info("abhi76 downloadWithProgress onreadystatechange file3dxyz:2:",
                                        tempIdx, tempCurrentFile3dListLength, response, returnUrl)
                                    },
                                    isReturnUrl: true,
                                  });
                                }
                              }
                              prevFile3dList = currentFile3dList.slice(0); // Why slice? No difference
                              console.info("abhi76 onreadystatechange fileURL contents2",
                                prevFile3dList, prevFile3dList.length)
                              
                            });
                          }
                        }
                      });
                    }

	//*************************************************************
    //fetch('//localhost:8000/download', {
    // fetch('//169.38.82.69:8000/download', {
    //  method: 'POST',
    //  body: user
    //})
    //.then((response) => {
    //  console.log(response);
      // response.blob().then((result)=>{ 
      //   console.log("HiRenderDemo:handleGet3DFiles : /download : result",result) 
      // })
    //  response.blob().then(blob => {
    //    let url = window.URL.createObjectURL(blob);
    //    let a = document.createElement('a');
    //    a.href = url;
    //    a.download = 'hiRenderDemoPackage.7z';
    //    a.click();
    //  });
    //}) 
    //.catch((error) => {
    //  console.log("HiRenderDemo:handleGet3DFiles : /download : error", error);
    //})
  };

  const handlePostData = (src) => {
    console.log("HiRenderDemo:handlePostData:src = ",src);

    // setting up the reader
    const reader = new FileReader();
    reader.readAsDataURL(src);

    reader.addEventListener('load', (event) => {
    //   video.src = event.target.result;
        console.log("HiRenderDemo:handlePostData:event.target.result = ",event.target.result);
        var data = event.target.result; // this is the content!
        console.log("handlePostData:data",data );
        axios.post('//localhost:8000/upload', data)
        .then((response) => {
          console.log('Upload Success');
          onSuccess(response.data)
        })
        .catch((e) => {
          console.log('Upload Error')
        })
    });

  }

  const handlePlayRecordedVideo = (globalBlobs,) => {
    if(manualUpload == true) {
      const gumVideo = document.getElementById('upload');
      gumVideo.play();
    } else {
      var blobs = [];
      if (globalBlobs != undefined) {
        blobs = globalBlobs;
      } else {
        blobs = recordedBlobs;
      }
      const superBuffer = new Blob(blobs, { type: "video/webm" });
      recordedVideo.src = null;
      recordedVideo.srcObject = null;
      recordedVideo.src = window.URL.createObjectURL(superBuffer);
      recordedVideo.controls = true;
      recordedVideo.play();
    }
  };

  const handleDownloadRecordedVideo = (globalBlobs) => {
    // const gumVideo = document.querySelector('video#gum');
    // gumVideo.srcObject.getTracks().forEach(track => track.stop());
    // handleStopWebCam()
    var blobs = [];
    if (globalBlobs != undefined) {
      blobs = globalBlobs;
    } else {
      blobs = recordedBlobs;
    }
    // console.log(
    //   "handleDownloadRecordedVideo:recordedBlobs, globalBlobs, blobs : ",
    //   recordedBlobs,
    //   globalBlobs,
    //   blobs
    // );
    const blob = new Blob(blobs, { type: "video/mp4" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "hiRender_Demo_2D_Video.mp4";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  };

  const handleDataAvailable = (event) => {
    console.log("handleDataAvailable", event, event.data);
    let recordedBlobs2 = [];
    if (event.data && event.data.size > 0) {
      recordedBlobs2.push(event.data);
      //setRecordedBlobs(recordedBlobs.push(event.data));
      console.log("ani:recordedBlobs: ", recordedBlobs);
      dispatch(handle_recordedBlobs(recordedBlobs2));
      if(autoPlayAndDownload == true){
        handlePlayRecordedVideo(recordedBlobs2);
        handleDownloadRecordedVideo(recordedBlobs2);
      }
    }
  };

  const exportUserInfo = () => {
    const userInfo = {
      pid: "101",
      name: "lohith",
      email: "lohi@gmail.com",
      room: "1234",
      pn: 3000,
      time_start: new Date()
    }
    // const fileData = JSON.stringify(userInfo);
    // const blob = new Blob([fileData], { type: "text/plain" });
    // const url = URL.createObjectURL(blob);
    // const link = document.createElement("a");
    // link.download = "start_2dto3d_hi_to_ec2_" 
    //                 + userInfo.room 
    //                 + "_" 
    //                 + userInfo.pid
    //                 + "_" 
    //                 + userInfo.pn 
    //                 + "_" 
    //                 + userInfo.time_start 
    //                 + ".txt";
    // link.href = url;
    // link.click();
    console.log("HiRenderDemo:exportUserInfo: userInfo",userInfo);
  }

  const startRecording = () => {
    // setWebCamRecordStart(true)
    if (isVideoRecorderStarted == false) {
      dispatch(handle_videoRecorder(true));
    }
    // recordedBlobs = [];
    try {
      let options = { mimeType: "video/webm;codecs=vp9,opus" };
      // dispatch(handle_mediaRecorder(options));
      mediaRecorder = new MediaRecorder(window.stream, options);
    } catch (e) {
      console.error("Exception while creating MediaRecorder:", e);
    }
    // setTimeout(() => {
    console.log("Created MediaRecorder", mediaRecorder);
    mediaRecorder.onstop = (event) => {
      console.log("Recorder stopped: ", event);
      console.log("Recorded Blobs: ", recordedBlobs);
      // setPlaying(false);
      dispatch(handle_videoRecorder(false));
      dispatch(handle_videoRecordStatus(true));
    };
    console.log(
      "mediaRecorder.ondataavailable : ",
      mediaRecorder.ondataavailable
    );
    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start();

    //setPlaying(true);
    // setUploadOrDownloadCount(0);

    console.log("startRecording:MediaRecorder started", mediaRecorder);
    // }, 1000);
    exportUserInfo()
  };

  // const stopRecording = () => {
  //     console.log('stopRecording:MediaRecorder = ', mediaRecorder);
  //     mediaRecorder.stop();

  //     console.log('stopRecording:MediaRecorder stopped', mediaRecorder);
  //     setWebCamRecordStart(false)
  // }

  const handleSuccess = (stream) => {
    // recordButton.disabled = false;
    console.log("getUserMedia() got stream:", stream);
    window.stream = stream;

    const gumVideo = document.getElementById("gum");
    gumVideo.srcObject = stream;
    // setWebCamStart(true);
    dispatch(handle_webCam(true));
  };

  const handleStopWebCam = () => {
    const gumVideo = document.querySelector("video#gum");
    gumVideo.srcObject.getTracks().forEach((track) => track.stop());
    console.log("getUserMedia() stream stopped");
    // setWebCamStart(false);
    // setWebCamRecordStart(false);
    dispatch(handle_webCam(false));
    // dispatch(handle_videoRecorder(false));
  };

  async function init() {
    const constraints = {
      audio: {
        echoCancellation: { exact: true },
      },
      video: {
        width: 1280,
        height: 720,
      },
    };
    console.log("Using media constraints:", constraints);
    
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      handleSuccess(stream);
    } catch (e) {
      console.error("navigator.getUserMedia error:", e);
    }
  }

  return (
    <div>
      <div
        className={
          fullScreen === ""
            ? "hiRenderDemo-section"
            : "hiRenderDemo-section-full"
        }
      >
        {/* {(!isWebCamOn && !isVideoRecorderStarted && isVideoRecorded) ? 
        <div
          onClick={handleClearVideo}
          className="hiRenderDemo-live-back-button"
        >
          <ChevronLeftIcon /> Back
        </div> : 
        <Link to='/hiRender' 
          className="hiRenderDemo-live-back-button"
          onClick={()=>{
            dispatch(handle_activePage("hiRender"))
            dispatch(handle_videoRecordStatus(false));
            dispatch(handle_recordedBlobs([]));
            setRecordCounter(10);
          }}
        >
          <ChevronLeftIcon /> Back
        </Link>} */}
        <Link to='/hiRender' 
          className="hiRenderDemo-live-back-button"
          onClick={()=>{
            dispatch(handle_activePage("hiRender"))
            dispatch(handle_videoRecordStatus(false));
            dispatch(handle_recordedBlobs([]));
            setRecordCounter(10);
          }}
        >
          <ChevronLeftIcon /> Back
        </Link>
        <div
          className={
            fullScreen === ""
              ? "hiRenderDemo-Videos"
              : "hiRenderDemo-Videos-full"
          }
        >
          {isVideoRecorded != true ?
          <div
            className={
              fullScreen === "2D"
                ? "hiRenderDemo-2d-container-full"
                : "hiRenderDemo-2d-container"
            }
          >
            <div className="hiRenderDemo-2d-name">2D</div>

            {fullScreen === "2D" ? (
              <div
                className="hiRenderDemo-2d-icons"
                onClick={() => handleFullScreen("")}
              >
                <FullscreenExitIcon />
              </div>
            ) : (
              <div
                className="hiRenderDemo-2d-icons"
                onClick={() => handleFullScreen("2D")}
              >
                <FullscreenIcon />
              </div>
            )}
            {manualUpload == false ? 
            <video
              // id={ isVideoRecorded == true ? "recorded" : "gum" }
              id="gum"
              ref={recordedRef}
              muted
              autoPlay
              className="app__videoFeed hiRenderDemo-2d-video"
            ></video> : 
            files.map((file) => 
              <video 
                src={`//localhost:8000/${file.filename}`} 
                alt={file.originalname}
                id="upload"
                ref={recordedRef}
                muted
                autoPlay
                className="app__videoFeed hiRenderDemo-2d-video"
              />
            )}
            
          </div> : <></>}

          {/* <div
            className={
              fullScreen === "3D"
                ? "hiRenderDemo-3d-container-full"
                : "hiRenderDemo-3d-container"
            }
          >
            <div className="hiRenderDemo-3d-name">3D</div>
            {fullScreen === "3D" ? (
              <div
                className="hiRenderDemo-3d-icons"
                onClick={() => handleFullScreen("")}
              >
                <FullscreenExitIcon />
              </div>
            ) : (
              <div
                className="hiRenderDemo-3d-icons"
                onClick={() => handleFullScreen("3D")}
              >
                <FullscreenIcon />
              </div>
            )}
            <video
              id="recorded"
              muted
              autoPlay
              loop
              className="app__videoFeed hiRenderDemo-3d-video"
            ></video>
          </div> */}
        </div>
        {/* <div className='hiRenderDemo-loader'>
                </div> */}
        {/* <LinearProgress /> */}
        {/* <Box position="relative" display="inline-flex">
                    <LinearProgress className='hiRenderDemo-loader' variant="buffer" 
                                    value={uploadOrDownloadCount} />
                    <Box
                    bottom={0}
                    right={0}
                    top={0}
                    justifyContent="center"
                    left={0}
                    display="flex"
                    alignItems="center"
                    position="absolute"
                    >
                    {`${Math.round(uploadOrDownloadCount)}%`}
                    </Box>
                </Box> */}
        {/* {playing ? (
                    <div style={Parentdiv}>
                        <div style={Childdiv}>
                            <span style={progresstext}>{`${Math.round(uploadOrDownloadCount)}%`}</span>
                        </div>
                    </div>
                ):null} */}
        <div className="hiRenderDemo-buttons">

          {isWebCamOn ? (
            isVideoRecorderStarted ? (
              isVideoRecorded == true ? (
                <h1>
                  {"isWebCamOn= " +
                    isWebCamOn +
                    " isVideoRecorderStarted= " +
                    isVideoRecorderStarted +
                    " isVideoRecorded= " +
                    isVideoRecorded}
                </h1>
              ) : (
                <div
                  onClick={() => {
                    handleStopWebCam();
                    dispatch(
                      handle_videoRecorder(false),
                      handle_videoRecordStatus(true)
                    );
                  }}
                  className="hiRenderDemo-live-record-button"
                >
                  STOP RECORDING... / AUTO STOP IN {recordCounter} SECOND
                  {recordCounter == 1 ? "" : "S"}
                </div>
              )
            ) : (
              <div
                onClick={startRecording}
                className="hiRenderDemo-live-record-button"
              >
                RECORD
              </div>
            )
          ) : isVideoRecorded == true ? (
            <>
              {/* <div
                onClick={() => {
                  handlePlayRecordedVideo(recordedBlobs, files);
                }}
                className="hiRenderDemo-live-play-button"
              >
                PLAY
              </div> */}
              {all3DRecords && all3DRecords.name && all3DRecords.name.includes(user.uid) 
              ?//<form
              //  method="post" action="#" id="#" 
                // onSubmit={() => {
                //   handleGet3DFiles(recordedBlobs);
                // }}
              //  onClick={() => {
                  // handleDownloadRecordedVideo(recordedBlobs);
                  // handlePostData(recordedBlobs)
              //    handleGet3DFiles();
              //  }}
              //  className="hiRenderDemo-live-download-button"
              //>
              //  DOWNLOAD
              //</form>
	      <a className="hiRenderDemo-live-download-button" href={downloadLink} download="file">DOWNLOAD</a>
              :<form
		onload={dispatch(get3DRecords(user.uid))}
                method="" action="#" id="#" 
                className="hiRenderDemo-live-download-button"
              >
                PLEASE WAIT! CONVERTING TO 3D...
              </form>}
              {/* <div
                onClick={() => {
                  dispatch(handle_videoRecordStatus(false));
                  dispatch(handle_recordedBlobs([]));
                  setRecordCounter(10);
                }}
                className="hiRenderDemo-live-back-button"
              >
                Back
              </div> */}
            </>
          ) : (
            //<div onClick={init} className="hiRenderDemo-live-start-button">
            //  START
            //</div>
	    null
          )}
          {isWebCamOn ? (
            isVideoRecorderStarted ? null : (
              <div
                onClick={handleStopWebCam}
                className="hiRenderDemo-live-stop-button"
              >
                STOP CAM
              </div>
            )
          ) : isVideoRecorded == true ? null : (
            <FileUploader onSuccess={onSuccess}/>
          )}

        </div>
	{/*<a className="hiRenderDemo-live-download-button" href={downloadLink} download="file">download</a>*/}
	<a className="hiRenderDemo-live-download-button" href="https://www.airender.co.in:8000/output/final/1685167852610-GncEm9y4rKdj2gCMX7PBvxmtOUF2.7z" download="file">download</a>
	<div>

	</div>
      </div>
    </div>
  );
};

export default HiRenderDemo;
